@use "@fukuri-admins/ui/layout" as *;

.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100vh;
}

.contentWrapper {
  max-width: 600px;
}

.title {
  @include typography("Jp/20_W6");
  color: text("High");
  margin: 0 0 spacing("16");
}

.description {
  @include typography("Jp/14_W3");
  color: text("Middle");
  margin: 0 0 spacing("24");
  line-height: 1.75;
}

.fieldSection {
  display: flex;
  flex-direction: column;
  gap: spacing("12");
}

.monthRowList {
  display: flex;
  flex-direction: column;
  gap: spacing("8");
}

.monthRow {
  display: flex;
  align-items: center;
  gap: spacing("8");
}

.monthSelect {
  width: 200px;
}

.addButton {
  align-self: flex-start;
}

.actions {
  display: flex;
  gap: spacing("12");
  margin-top: spacing("24");
}
